<div class="page hug-final-review">
  <app-section-loader [loading]="loading || isSavingLoader"></app-section-loader>
  <section class="pre-engage-header">
    <h2 class="pre-engage-header__title">
        {{lessonName}}
      </h2>
      <div class="pre-engage-header__buttons">
        <button mat-raised-button color="white" class="hug-main-button" (click)="tutorTipModalOpen(true)">
          <img src="../../../assets/assets/images/svg/info-blue.svg" alt="Info icon">
          Tutor Tips
        </button>
      </div>
    </section>

    <nav class="hug-psc-navigation">

      <div class="hug-psc-navigation__nav">
        <button (click)="onBackClick()">
          <p>Back</p>
          <img src="../../../assets/assets/images/svg/arrow-back.svg" alt="previous">
          <p>Post engagement</p>
        </button>
      </div>

      <div class="hug-psc-navigation__container">
        <h2 class="hug-h2 text-center text-primary" style="font-size: 30px;">
          Post Engagement Review
        </h2>
      </div>

      <div class="d-block text-center">
        <button mat-raised-button color="primary" class="hug-main-button review-submit-btn mb-4" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </nav>

  <main class="mContent overflow-auto overflow-x-hidden">
    <app-section-loader [loading]="loading"></app-section-loader>
    <div class="hug-container pt-8">

      <div class="hug-frpb" *ngFor="let _ of sessionEngageDetails; let i = index">
        <div class="hug-frpb__rl">
          <h3 class="hug-frpb__rl-title">Words Missed</h3>
          <div class="hug-frpb__rl-container">
            <div class="hug-frpb__rl__box">
              <h5 class="hug-frpb__rl__box__title">Attempt 1</h5>
              <p class="hug-frpb__rl__box__words" *ngFor="let firstMissedWords of sessionEngageDetails[i]?.first_read_words;">{{firstMissedWords}}</p>
            </div>
            <div class="hug-frpb__rl__box">
              <h5 class="hug-frpb__rl__box__title">Attempt 2</h5>
              <p class="hug-frpb__rl__box__words" *ngFor="let secondMissedWords of sessionEngageDetails[i]?.second_read_words;">{{secondMissedWords}}</p>
            </div>
          </div>
        </div>

        <div class="hug-frpb__passage">
          <h3>Passage {{ i + 1 }} :</h3>
          <h4>{{sessionEngageDetails[i]?.passage_name}}</h4>
          <h5>All attempts completed!</h5>
        </div>

        <div class="hug-frpb__rl">
          <h3 class="hug-frpb__rl-title">Learning Outcomes</h3>
          <div class="hug-frpb__rl-container">
            <div class="hug-frpb__rl__box">
              <h5 class="hug-frpb__rl__box__title">Words Learned</h5>
              <p class="hug-frpb__rl__box__words" *ngFor="let wordsLearnt of sessionEngageDetails[i]?.words_learnt;">{{wordsLearnt}}</p>
            </div>
            <div class="hug-frpb__rl__box">
              <h5 class="hug-frpb__rl__box__title">WHIP Words</h5>
              <p class="hug-frpb__rl__box__words" *ngFor="let whipWords of sessionEngageDetails[i]?.whip_words;">{{whipWords}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal" [ngClass]="{'active':tutorTipModal}" id="modalExample">
        <div class="modal__box">
          <div class="modal__header">
            <h2>Tutor Tips</h2>
            <button class="close" aria-label="Close" (click)="tutorTipModalOpen(false)">×</button>
          </div>
          <div class="modal__body">
            <p [innerHTML]="tutorTips"></p>
          </div>
        </div>
      </div>
    </div>
  </main>

  <footer class="hug-tutor-footer pt-1">
    <div class="hug-container">
      <p class="hug-copyright">© Help Us Grow Reading Program</p>
    </div>
  </footer>
</div>